export default {
  transfers: null,
  transfer: null,
  error: false,
  success: false,
  errorMessage: "",
  successMessage: "",
};
